import React, { useCallback, useRef } from 'react';
import { BindUseScrollThreshold } from './bind-use-scroll-threshold';
import { UseScrollThresholdOptions } from './use-scroll-threshold-options';

const DEFAULT_THRESHOLD = 500;

export const useScrollThreshold = <T extends HTMLElement = HTMLElement>(
  callback: () => void,
  options: UseScrollThresholdOptions<T> = {},
): BindUseScrollThreshold => {
  const threshold = options.threshold || DEFAULT_THRESHOLD;
  const ref: React.RefObject<T> = options.ref || useRef<T>(null);

  const onScroll = useCallback(
    (e: React.UIEvent<T>): void => {
      if (options.onScroll) {
        options.onScroll(e);
      }

      if (ref.current && !options.disabled) {
        const { offsetHeight, scrollHeight, scrollTop } = ref.current;
        if (scrollHeight - scrollTop - offsetHeight < threshold) {
          callback();
        }
      }
    },
    [options.onScroll, options.threshold, callback],
  );

  return { onScroll, ref };
};
